export enum ReportTypes {
  paymentInvoice = 'DI',
  commercialInvoice = 'CI',
  despatchNote = 'DS',
  goodsDeliveryNote = 'GD',
  invoice = 'IV',
  purchaseOrderPrint = 'PO',
  pickingList = 'PK',
  pickList = 'PL',
  purchasePickingList = 'PP',
  proforma = 'PF',
  quotation = 'QT',
  releaseOrder = 'RL',
  salesOrderConfirmation = 'SO',
  salesOrderBalances = 'SB',
  salesOrderBackOrder = 'BK',
  salesOrderCollection = 'CO',
  supplierPickingList = 'SP',
  transferNote = 'TN',
  transferRequest = 'TR',
}
